import { render, staticRenderFns } from "./project-dialog.vue?vue&type=template&id=03a4ed24&scoped=true"
import script from "./project-dialog.vue?vue&type=script&lang=js"
export * from "./project-dialog.vue?vue&type=script&lang=js"
import style0 from "./project-dialog.vue?vue&type=style&index=0&id=03a4ed24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4ed24",
  null
  
)

export default component.exports